/* src/app/modules/institutions/institutions-orders2/institutions-orders2.component.scss */
/*# sourceMappingURL=institutions-orders2.component.css.map */
